var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "white",
    strokeOpacity: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7273 18.3636C26.7273 23.3131 20.3636 27.5556 20.3636 27.5556C20.3636 27.5556 14 23.3131 14 18.3636C14 16.6759 14.6705 15.0573 15.8639 13.8639C17.0573 12.6705 18.6759 12 20.3636 12C22.0514 12 23.67 12.6705 24.8634 13.8639C26.0568 15.0573 26.7273 16.6759 26.7273 18.3636Z",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3634 20.4851C21.5349 20.4851 22.4846 19.5354 22.4846 18.3639C22.4846 17.1924 21.5349 16.2427 20.3634 16.2427C19.1919 16.2427 18.2422 17.1924 18.2422 18.3639C18.2422 19.5354 19.1919 20.4851 20.3634 20.4851Z",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap1);
export default __webpack_public_path__ + "static/media/map1.2a7bbb4097d34fde049f2c176b20238d.svg";
export { ForwardRef as ReactComponent };